import { type FunctionComponent } from 'react';

import { HorizontalContainer } from '@american-autonomy/ag-ui';

import RadioButton from 'components/RadioButton';
import DropdownText from 'components/text/DropdownText';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const SingleSelectItem: FunctionComponent<Props> = ({
    className = '',
    item,
    itemSelected,
    onClick,
    testId = TEST_ID
}) => {
    const isSelected = itemSelected?.value === item.value;

    const selectedTextStyles = isSelected ? styles.selectedText : '';

    return (
        <HorizontalContainer
            className={`${styles.singleSelectItem} ${className}`}
            key={item.value}
            onClick={onClick}
            testId={testId}>
            <RadioButton className={styles.radioButton} isSelected={isSelected} />

            <DropdownText className={selectedTextStyles} text={item.label} />
        </HorizontalContainer>
    );
};

export default SingleSelectItem;
